import { OnInit, Component, Renderer2, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProductService } from '../services/product.service';
import { SubcategoryService } from '../services/subcategory.service';
import { catchError, filter } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../environments/environment';
import { AlertService } from '../services/alert.service';
import { CategoryService } from '../services/category.service';
import { MaterialService } from '../services/material.service';
import { PrintgroupService } from '../services/printgroup.service';
import { UploadService } from '../services/upload.service';
import { StorageService } from '../services/storage.service';
import jwt_decode from "jwt-decode";
import { Router } from "@angular/router";
import { of } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, throwError } from 'rxjs';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { SpinnerService } from './../services/spinner.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
// import { ToolbarService, LinkService, ImageService, HtmlEditorService, RichTextEditorComponent  } from '@syncfusion/ej2-angular-richtexteditor';
@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.css'],
  // providers: [ToolbarService, LinkService, ImageService, HtmlEditorService]
  providers:[]
})

export class ProductComponent implements OnInit {
  baseUrl = environment.baseUrl;
  productname : any;
  items: any;
  categories: any;
  materials: any;
  printgroups: any;
  subcategories: any;
  imagesource: any;
  productcategoryid: number;
  filename: any;
  public username;
  createdby: string;
  @ViewChild('addProduct') elProduct: ElementRef;
  private route: ActivatedRoute;
  id:number;
  AddShowHide:boolean = true;
  EditShowHide:boolean = true;
  CreateShowHide:boolean = false;
  UpdateShowHide:boolean = false;
  CancelShowHide = false;
  isShown:boolean = true;
  reverse: boolean = false;
  createdate: Date;
  public filter: string = '';
  availableSubCategories:any;

  public Editor = ClassicEditor;

  @ViewChild('fileInput', {static: false})
  InputVar: ElementRef;

  // @ViewChild('fromRTE')
  // private rteEle: RichTextEditorComponent;

  frmProduct = new FormGroup({
    Nomenclature: new FormControl('', [Validators.required, Validators.minLength(1)]),
    PrintGroup: new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductCategoryId : new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductSubCategoryId  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    ProductName  : new FormControl(''),
    Title  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    MaterialId  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    Size  : new FormControl(),
    LidColor  : new FormControl(),
    FeaturesBenefits  : new FormControl('', [Validators.required, Validators.minLength(1)]),
    CupHeight  : new FormControl(),
    FlushFill  :new FormControl(),
    PracticalFill  : new FormControl(),
    WidthAtBottom  : new FormControl(),
    WidthAtRim  : new FormControl(),
    ItemDimensions  : new FormControl(),
    IsEcotainer  : new FormControl(false),
    IsCompliancePackaging  : new FormControl(false),
    ProductImage  : new FormControl('', [Validators.required])
  });

  config = {
    id: 'Product',
    itemsPerPage: environment.pagination.pagesize,
    currentPage: 1,
    totalItems: 0,
    pagerowcount: 0

  };

  param = environment.pagination;
  // {
  //   SortColumnName :"Modifiedby",
  //   SortOrder :"DESC",
  //   PageSelected:0,
  //   PageSize:2
  // };

  constructor(private renderer: Renderer2,
              private _productservice: ProductService,
              private _categoryservice: CategoryService,
              private _subcategoryservice: SubcategoryService,
              private _materialservice: MaterialService,
              private _printgroupservice: PrintgroupService,
              private _uploadservice: UploadService,
              private _alertService: AlertService,
              private router: Router,
              public storage: StorageService,
              private SpinnerService: NgxSpinnerService,
              private authService: MsalService,
              private msalBroadcastService: MsalBroadcastService,
              private spinner: SpinnerService) {
                // const tokenitems = { ...localStorage };
                // if(tokenitems.TokenInfo != undefined) {
                //     var clienttoken = jwt_decode(JSON.parse(tokenitems.TokenInfo).access_token);
                //     var isAdmin;
                //     var groups;
                //     //console.log('clienttoken');
                //     //console.log(clienttoken);
                //     this.username = clienttoken["unique_name"];
                //     groups = clienttoken["groups"].split(',');

                //     isAdmin = groups.indexOf("GPI-Aces-Admins",0) != -1;
                //     if(!isAdmin){
                //         this.router.navigate(['/accessdenied']);
                //     }
                // }

  }

  ngOnInit() {

//     type IdTokenClaims  = {
//       roles: string[]
//   };
//         this.msalBroadcastService.inProgress$
//         .pipe(
//           filter((status: InteractionStatus) => status === InteractionStatus.None)
//         )
//         .subscribe(() => {
//          var account=this.authService.instance.getActiveAccount();
//          console.log(this.authService.instance.getActiveAccount()?.idTokenClaims);
//          const roles = (account.idTokenClaims as IdTokenClaims).roles;
//          console.log(roles);
//          const claims = account.idTokenClaims as { [key: string]: any };
// const roles3 = claims.roles;
// console.log(roles3);

// // and this does also work:
// const roles4 = claims['roles'];
// console.log(roles4);
//         });
    this.spinner.showSpinner();
    const activeAccount = this.authService.instance.getActiveAccount();
    if (activeAccount) {
      this.username = activeAccount.username;
    }
    //this.isShown = true;
    //console.log(this.param);
    this.GetCategories();
    this.GetSubCategories();
    this.GetPrintGroups();
    this.GetMaterials();
    this.GetProducts();
    //console.log(this.filename);
    this.spinner.hideSpinner();
    
  }

  SortOder(colName, boolean) {
    if (boolean == true) {
        this.items.sort((a, b) => a[colName] < b[colName] ? 1 : a[colName] > b[colName] ? -1 : 0)
        this.reverse = !this.reverse
    }
  else {
      this.items.sort((a, b) => a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0)
      this.reverse = !this.reverse
  }
}
onPageChange(number: number) {
  this.config.currentPage = number;
  this.config.pagerowcount = this.config.itemsPerPage * (this.config.currentPage == 0 ? this.config.currentPage + 1 : this.config.currentPage);
  this.config.pagerowcount = this.config.pagerowcount > this.config.totalItems ? this.config.totalItems : this.config.pagerowcount;
}

onPageBoundsCorrection(number: number) {
  this.config.currentPage = number;
  this.config.pagerowcount = this.config.itemsPerPage * (this.config.currentPage == 0 ? this.config.currentPage + 1 : this.config.currentPage);
  this.config.pagerowcount = this.config.pagerowcount > this.config.totalItems ? this.config.totalItems : this.config.pagerowcount;
}

  Cancel(){
    this.spinner.showSpinner();
    this.id = 0;
    this.frmProduct.setValue({
                              Nomenclature:"",
                              PrintGroup:"",
                              ProductCategoryId: "",
                              ProductSubCategoryId: "",
                              ProductName: "",
                              Title: "",
                              MaterialId:"",
                              Size:"",
                              LidColor:"",
                              FeaturesBenefits:"",
                              CupHeight:"",
                              FlushFill:"",
                              PracticalFill:"",
                              WidthAtBottom:"",
                              WidthAtRim:"",
                              ItemDimensions:"",
                              IsEcotainer:false,
                              IsCompliancePackaging:false,
                              ProductImage:""

                              });

    //console.log("cancel");
    this.availableSubCategories=[];
    //console.log(this.InputVar);
    this.InputVar.nativeElement.value="";
    this.filename = '';
    this.AddShowHide = true;
    this.EditShowHide = true;
    this.CreateShowHide = false;
    this.UpdateShowHide =false;
    this.CancelShowHide = false;

    this.spinner.hideSpinner();
  }

  GetProducts() {
    this._productservice.getProductList().subscribe((data: any) => {
      //console.log('products');
      //console.log(data);
      this.items = data;
      this.config.totalItems = this.items.length;
      setTimeout(() => { this.SpinnerService.hide() }, 500);

   });
  }



  GetMaterials() {
    this._materialservice.getMaterials().subscribe((data: any) => {
      //console.log('materials');
      //console.log(data);
      var stringifiedmaterials = JSON.stringify(data);
      this.materials = JSON.parse(stringifiedmaterials);

   });
  }

  GetSubCategories() {
    this._subcategoryservice.getSubCategories().subscribe((data: any) => {
      //console.log('subcategories');
      //console.log(data);
      var stringifiedsubcategories = JSON.stringify(data);
      this.subcategories = JSON.parse(stringifiedsubcategories);
   });
  }
  UpdateAvailableCategories(){
    //console.log(this.frmProduct.get('ProductCategoryId').value);
    this.availableSubCategories = this.subcategories.filter(s => s.productCategoryId===this.frmProduct.get('ProductCategoryId').value);
  }
  GetCategories() {
    this._categoryservice.getProductCategories().subscribe((data: any) => {
      //console.log('categories');
      //console.log(data);
      var stringifiedcategories = JSON.stringify(data);
      this.categories = JSON.parse(stringifiedcategories);

   });
  }

  GetPrintGroups() {
    this._printgroupservice.getPrintGroups().subscribe((data: any) => {
      //console.log('printgroups');
      //console.log(data);
      var stringifiedprintgroups = JSON.stringify(data);
      this.printgroups = JSON.parse(stringifiedprintgroups);
   });
  }




  pageChanged(event){
    this.config.currentPage = event;
    this.param.PageSelected = event;
    this.GetProducts();
  }

  setFilename(files) {
    if (files[0]) {
      this.filename = files[0].name;
      this.isShown = false;
      //console.log("filename");
      //console.log(this.filename);
    }
  }

  save(files, frmProduct) {
    var start = Date.now().toString();
    var timestampSuffix = start.substr(start.length - 4);

    if(this.filename===undefined)
      return;
    const formdata = new FormData();
    var filename ='';


    filename = this.frmProduct.value.Nomenclature + this.frmProduct.value.PrintGroup + timestampSuffix+  '.jpg';
    if (files[0]) {
      //console.log(files[0].name);

      formdata.append(filename, files[0]);
      //console.log("append" )
    }
    //console.log(filename);
    this.frmProduct.patchValue({ProductName: filename});
    //console.log(formdata);
    //console.log(this.frmProduct.value.ProductName);

    this._uploadservice
      .upload(formdata)
      .subscribe(({ path }) => (this.imagesource = path));
    formdata.delete(filename);

    }

  EditProduct(item){
    this.spinner.showSpinner();
    //console.log(item);

    this.id = item.id;
    //console.log(this.id);
    this.createdby = item.createdBy;
    this.createdate = item.creationDate;
    //console.log(item.productCategoryId);
    this.availableSubCategories = this.subcategories.filter(s => s.productCategoryId==item.productCategoryId);
    this.productname = item.productName;
    this.frmProduct.setValue({
      Nomenclature:item.nomenclature,
      PrintGroup:item.printGroup,
      Title:item.title,
      ProductCategoryId:item.productCategoryId,
      ProductSubCategoryId:item.productSubcategoryId,
      MaterialId:item.materialId,
      ProductName:item.productName,
      Size:item.size,
      LidColor: item.lidColor,
      CupHeight:item.cupHeight,
      FlushFill:item.flushFill,
      PracticalFill:item.practicalFill,
      WidthAtBottom: item.widthatBottom,
      WidthAtRim: item.widthatRim,
      ItemDimensions: item.itemDimensions,
      IsEcotainer: item.isEcotainer,
      IsCompliancePackaging: item.isCompliancePackaging,
      FeaturesBenefits:item.featuresBenefits,
      ProductImage:item.productName
    });

    this.EditShowHide = false;
    this.AddShowHide = false;
    this.CreateShowHide = false;
    this.UpdateShowHide =true;
    this.CancelShowHide = true;

    //console.log(this.EditShowHide);
    //console.log(this.AddShowHide);
    //console.log(this.UpdateShowHide);

    this.spinner.hideSpinner();

  }

  AddProduct(){
    this.spinner.showSpinner();
    this.id = 0;
    this.AddShowHide = false;
    this.EditShowHide = false;
    this.CreateShowHide = true;
    this.UpdateShowHide =false;
    this.CancelShowHide = true;
    this.spinner.hideSpinner();
  }

  Validation(frmPr:FormGroup){
    let invalidfield : String = '';

  if (frmPr.invalid) {
      Object.keys(frmPr.controls).forEach((key) => {
          if(frmPr.get(key).invalid == true){
            //console.log(frmPr.get(key).value);
              // Add validation
              if (key === "Nomenclature") {
                if (invalidfield == '') {
                    invalidfield = "Please enter Nomenclature" + "<br/>";
                } else {
                    invalidfield += "Please enter Nomenclature" + "<br/>";
                }
              }
              if (key === "Print Group") {
                if (invalidfield == '') {
                    invalidfield = "Please enter Print Group" + "<br/>";
                } else {
                    invalidfield += "Please enter Print Group" + "<br/>";
                }
              }


          }
      });
      this._alertService.showError(invalidfield);
      //console.log(frmPr);
    }
  }
  CreateProduct(files) {
    this.spinner.showSpinner();
    this.isShown = true;
    if (this.frmProduct.invalid) {
      this.Validation(this.frmProduct);
      this.spinner.hideSpinner();
      return;
    }
    //console.log('saving file');
    //console.log(files);
    this.save(files, this.frmProduct);
    if (this.frmProduct.get('IsEcotainer').value === undefined)
    {

      this.frmProduct.get('IsEcotainer').value == false;
    }

    if (this.frmProduct.get('IsCompliancePackaging').value === undefined)
    {

      this.frmProduct.get('IsCompliancePackaging').value == false;
    }

   
    let ProductModel = {
      Nomenclature: this.frmProduct.get('Nomenclature').value,
      PrintGroup: this.frmProduct.get('PrintGroup').value,
      ProductCategoryId: this.frmProduct.get('ProductCategoryId').value,
      ProductSubCategoryId: this.frmProduct.get('ProductSubCategoryId').value,
      ProductName: this.frmProduct.get('ProductName').value,
      Title: this.frmProduct.get('Title').value,
      MaterialId: this.frmProduct.get('MaterialId').value,
      Size: parseInt(this.frmProduct.get('Size').value),
      LidColor: this.frmProduct.get('LidColor').value,
      FeaturesBenefits: this.frmProduct.get('FeaturesBenefits').value,
      CupHeight: this.frmProduct.get('CupHeight').value,
      FlushFill: this.frmProduct.get('FlushFill').value,
      PracticalFill: this.frmProduct.get('PracticalFill').value,
      WidthAtBottom: this.frmProduct.get('WidthAtBottom').value,
      WidthAtRim: this.frmProduct.get('WidthAtRim').value,
      ItemDimensions: this.frmProduct.get('ItemDimensions').value,
      IsEcotainer: this.frmProduct.get('IsEcotainer').value,
      IsCompliancePackaging: this.frmProduct.get('IsCompliancePackaging').value,
      CreatedBy: this.username,
      CreationDate: new Date(),
      LastModifiedBy: this.username,
      LastModificationDate: new Date()


    }
    //console.log(ProductModel);

    let retvalue = this._productservice.postProduct(ProductModel);
    retvalue.pipe(
      catchError(this.handleError)).subscribe((value: any) => {
        this.param.SortOrder = "DESC";
      this.GetProducts();
      this.Cancel();
      this._alertService.showSuccess("Record created successfully");
      this.InputVar.nativeElement.value="";

      })

      this.spinner.hideSpinner();
    }

    handleError(error) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
          // client-side error
          errorMessage = `Error: ${error.error.message}`;
      } else {
          // server-side error
          errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //console.log(errorMessage);
      return throwError(errorMessage);
  }
    UpdateProduct(files) {
      this.spinner.showSpinner();
      
      if (this.frmProduct.invalid) {
        this.Validation(this.frmProduct);
        this.spinner.hideSpinner();
        return;

      }
      //console.log('update product');
      //console.log(this.filename);
      if(files[0] != null){
        //console.log('saving file');
        this.save(files, this.frmProduct);
        //console.log(this.InputVar);

      }
      //console.log('productname');
      //console.log(this.frmProduct.get('ProductName').value);
      let ProductModel = {
        Id: this.id,
        Nomenclature: this.frmProduct.get('Nomenclature').value,
        PrintGroup: this.frmProduct.get('PrintGroup').value,
        ProductCategoryId: this.frmProduct.get('ProductCategoryId').value,
        ProductSubCategoryId: this.frmProduct.get('ProductSubCategoryId').value,
        ProductName: this.frmProduct.get('ProductName').value,
        Title: this.frmProduct.get('Title').value,
        MaterialId: this.frmProduct.get('MaterialId').value,
        Size: parseInt(this.frmProduct.get('Size').value),
        LidColor: this.frmProduct.get('LidColor').value,
        FeaturesBenefits: this.frmProduct.get('FeaturesBenefits').value,
        CupHeight: this.frmProduct.get('CupHeight').value,
        FlushFill: this.frmProduct.get('FlushFill').value,
        PracticalFill: this.frmProduct.get('PracticalFill').value,
        WidthAtBottom: this.frmProduct.get('WidthAtBottom').value,
        WidthAtRim: this.frmProduct.get('WidthAtRim').value,
        ItemDimensions: this.frmProduct.get('ItemDimensions').value,
        IsEcotainer: this.frmProduct.get('IsEcotainer').value,
        IsCompliancePackaging: this.frmProduct.get('IsCompliancePackaging').value,
        LastModifiedBy: this.username,
        LastModificationDate: new Date(),
        CreatedBy: this.createdby,
        CreationDate: this.createdate

      }
      //console.log(ProductModel);

      let retvalue = this._productservice.putProduct( ProductModel);

      retvalue.pipe(
        catchError(err => {
          //console.log(err);
          return of(null);
        })).subscribe((value: any) => {
          this.param.SortOrder = "DESC";

          this.GetProducts();
          this.Cancel();
          setTimeout("",1000);
          this._alertService.showSuccess("Record updated successfully");
          this.InputVar.nativeElement.value="";
          this.isShown=true;

        })

        this.spinner.hideSpinner();
  }

  DeleteProduct(productId: number) {
    if (confirm('Are you sure to delete this record ?')) {
      this._productservice.deleteProduct(productId).subscribe(
        (data: any) => {
          this._alertService.showSuccess("Deleted successfully");
        },
        err => {
          if (err.status == 400)
            this._alertService.showError("No data exists");
          else
            this._alertService.showError("Bad request");
        }
      );
      this.GetProducts();
    }
  }
  }






